(() => {
  if (window.sdTreatmentInquiryReady) return;
  window.sdTreatmentInquiryReady = true;
  document.addEventListener('click', event => {
    const trigger = event.target.closest('a[data-sd-treatment-inquiry]');
    if (!trigger) return;
    const field = document.querySelector('#behandlungsanfrage [data-sd-inquiry-treatment]');
    if (!field) return;
    const treatment = trigger.dataset.sdTreatmentInquiry;
    if (treatment) {
      field.value = treatment;
      field.dispatchEvent(new Event('input', { bubbles: true }));
    }
  });
})();
